import { EChainType } from '@/constants/chains'
import { WALLET_ENDPOINT } from '@/data/endpoint'

import { IResponse, Model, ObjectsFactory } from '../../core'

export interface ILinkWalletPayload {
  wallets: string[]
}

export interface ITrackWalletConnectedPayload {
  wallet: string
  walletType: EChainType
  walletName: string
  metadata: any
}

export class LinkWallet extends Model {
  static config = { endpoint: '' }

  static objects = ObjectsFactory.factory<void>(LinkWallet.config)

  static linkWallet(payload: ILinkWalletPayload) {
    return this.service.post<IResponse<void>>({
      url: WALLET_ENDPOINT.LINK_WALLET,
      payload,
    })
  }

  static trackWalletConnected(payload: ITrackWalletConnectedPayload) {
    return this.service.post<IResponse<void>>({
      url: WALLET_ENDPOINT.TRACK_CONNECTED_WALLET,
      payload,
    })
  }
}

LinkWallet.init(LinkWallet.config)
